import {Locale} from '@/utils/constants'
import {Jurisdiction} from '@/utils/countries/constants'
import {routeTo} from '@/utils/router'

type WhyTramaBenefit = {
  imageSrc: string
  imageAlt: string
  title: string
  average: string
  trama: {
    description: string
    linkHrefs?: ({[key in Locale]?: string} | string)[]
    isLocalizedLink?: boolean
  }
}

export const useWhyTramaContent = (countryCode?: Jurisdiction) => {
  const country = countryCode?.toLowerCase()
  const verificationLink = country
    ? {
        pathname: routeTo.verification.form(),
        query: {
          countrySpecific: country,
          country: country,
        },
      }
    : routeTo.verification.form()

  const pricingLink = country
    ? {
        pathname: routeTo.pricing(),
        query: {
          countrySpecific: country,
        },
      }
    : routeTo.pricing()

  return {
    title: 'marketing-pages-common.why-trama-table-title',
    description: 'marketing-pages-common.why-trama-table-desc',
    buttonLink: verificationLink,
    buttonText: 'button-start-with-lawyer-check',
    industryAverageTitle: 'marketing-pages-common.why-trama-table-average-title',
    benefitColumnTitle: 'marketing-pages-common.why-trama-table-benefit-column',
    benefits: [
      {
        imageSrc: '/images/icons/why-trama/shield-checkmark.svg',
        imageAlt: 'Shield with a checkmark',
        title: 'marketing-pages-common.why-trama-table-row-0-title',
        average: 'marketing-pages-common.why-trama-table-row-0-average-desc',
        trama: {
          description: 'marketing-pages-common.why-trama-table-row-0-trama-desc-with-link',
          linkHrefs: [routeTo.trademarkSearch()],
        },
      },
      {
        imageSrc: '/images/icons/why-trama/checklist.svg',
        imageAlt: 'Checklist',
        title: 'marketing-pages-common.why-trama-table-row-1-title',
        average: 'marketing-pages-common.why-trama-table-row-1-average-desc',
        trama: {
          description: 'marketing-pages-common.why-trama-table-row-1-trama-desc-with-link',
          linkHrefs: [verificationLink, routeTo.legalServices(), routeTo.brandMonitoring.home()],
        },
      },
      {
        imageSrc: '/images/icons/why-trama/globe-shield.svg',
        imageAlt: 'Glove with a shield',
        title: 'marketing-pages-common.why-trama-table-row-2-title',
        average: 'marketing-pages-common.why-trama-table-row-2-average-desc',
        trama: {
          description: 'marketing-pages-common.why-trama-table-row-2-trama-desc-with-link',
          linkHrefs: [routeTo.internationalTm()],
        },
      },
      {
        imageSrc: '/images/icons/why-trama/person-checkmark.svg',
        imageAlt: 'Person with a checkmark',
        title: 'marketing-pages-common.why-trama-table-row-3-title',
        average: 'marketing-pages-common.why-trama-table-row-3-average-desc',
        trama: {
          description: 'marketing-pages-common.why-trama-table-row-3-trama-desc-with-link',
          linkHrefs: [routeTo.howItWorks()],
        },
      },
      {
        imageSrc: '/images/icons/why-trama/application-star.svg',
        imageAlt: 'Application with a star',
        title: 'marketing-pages-common.why-trama-table-row-4-title',
        average: 'marketing-pages-common.why-trama-table-row-4-average-desc',
        trama: {
          description: 'marketing-pages-common.why-trama-table-row-4-trama-desc-with-link',
          linkHrefs: [
            {
              [Locale.en]: routeTo.blog.industryArticle(
                'legal',
                'how-to-maximise-the-chances-of-a-successful-trademark-registration',
              ),
              [Locale.sk]: routeTo.blog.industryArticle(
                'legal',
                'ako-maximalizovat-sance-na-uspesnu-registraciu-ochrannej-znamky',
              ),
              [Locale.cs]: routeTo.blog.industryArticle(
                'legal',
                'jak-maximalizovat-sance-na-uspesnou-registraci-ochranne-znamky',
              ),
              [Locale.es]: routeTo.blog.industryArticle(
                'legal',
                'como-maximizar-las-posibilidades-de-exito-en-el-registro-de-una-marca',
              ),
            },
          ],
        },
      },
      {
        imageSrc: '/images/icons/why-trama/price-tag.svg',
        imageAlt: 'Price tag',
        title: 'marketing-pages-common.why-trama-table-row-5-title',
        average: 'marketing-pages-common.why-trama-table-row-5-average-desc',
        trama: {
          description: 'marketing-pages-common.why-trama-table-row-5-trama-desc-with-link',
          linkHrefs: [pricingLink],
        },
      },
      {
        imageSrc: '/images/icons/why-trama/amazon-brand-registry.svg',
        imageAlt: 'Amazon brand registry',
        title: 'marketing-pages-common.why-trama-table-row-6-title',
        average: 'marketing-pages-common.why-trama-table-row-6-average-desc',
        trama: {
          description: 'marketing-pages-common.why-trama-table-row-6-trama-desc-with-link',
          linkHrefs: [
            routeTo.blog.industryArticle(
              'ecommerce',
              'register-your-trademark-with-trama-and-save-over-gbp40-000-in-potential',
            ),
          ],
          isLocalizedLink: false,
        },
      },
      {
        imageSrc: '/images/icons/why-trama/ice-cream.svg',
        imageAlt: 'Ice cream',
        title: 'marketing-pages-common.why-trama-table-row-7-title',
        average: '',
        trama: {
          description: 'marketing-pages-common.why-trama-table-row-7-trama-desc',
        },
      },
    ] as WhyTramaBenefit[],
  }
}
